import { useEffect, useRef } from "react";

import {
  LINK_TYPES,
  useStartBookingFlowMutation,
  type VisitType,
} from "~/services";
import { useBookingFlowStore } from "~/stores";

export const useStartStaffBookingFlow = () => {
  const latestRequest = useRef(0);
  const currentVisitType = useRef<VisitType | null>(null);
  const { mutate: startBookingFlow } = useStartBookingFlowMutation();

  useEffect(() => {
    return () => {
      latestRequest.current += 1;
      useBookingFlowStore.setState({ flow: null });
    };
  }, []);

  return (visitType: VisitType) => {
    if (currentVisitType.current === visitType) return;

    currentVisitType.current = visitType;
    const request = ++latestRequest.current;
    useBookingFlowStore.setState({ flow: null });

    startBookingFlow(
      { appointmentType: visitType, linkType: LINK_TYPES.STAFF_SCHEDULING },
      {
        onSuccess: (data) => {
          if (request !== latestRequest.current) return;

          useBookingFlowStore.setState({
            flow: { id: data.id, appointmentType: visitType },
            isProviderView: true,
          });
        },
        onError: () => {
          if (request === latestRequest.current) {
            currentVisitType.current = null;
          }
        },
      },
    );
  };
};
